/**
 * Determines whether the current host serves the End-User app (app.teamity.io)
 * or the Coach workspace (coach.teamity.io). Replaces the old isPlatformMode().
 *
 * VITE_APP_CONTEXT environment variable can override for local dev
 * (e.g. running both surfaces from localhost without /etc/hosts).
 */
export type AppContext = 'app' | 'coach';

export function getAppContext(): AppContext {
  const override = import.meta.env.VITE_APP_CONTEXT;
  if (override === 'coach' || override === 'app') return override;
  if (typeof window === 'undefined') return 'app';
  return window.location.hostname.startsWith('coach.') ? 'coach' : 'app';
}
